import { useParams, useNavigate } from "react-router-dom";
import { TaskForm } from "../../../components/task/TaskForm";
import { useEffect, useState } from "react";
import { useTasks } from "@/hooks/workflow/useTasks";
import LoaderComponent from "@/components/common/LoaderComponent";

const EditTask = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { tasks, loading } = useTasks();
  const [taskData, setTaskData] = useState<{ id: string; taskName: string } | undefined>();

  useEffect(() => {
    if (!loading && tasks.length > 0 && id) {
      const task = tasks.find(t => t.task_id.toString() === id);
      if (task) {
        setTaskData({
          id: task.task_id.toString(),
          taskName: task.task_name
        });
      } else {
        // Task not found, redirect to tasks list
        navigate("/admin/workflow?tab=tasks");
      }
    }
  }, [tasks, loading, id, navigate]);

  if (loading || !taskData) {
    return <LoaderComponent size="lg" text="Loading task data..." />;
  }

  return <TaskForm initialData={taskData} isEdit={true} />;
};

export default EditTask;